(() => {
  const key = 'maslow:browse-return:v1';
  const restoreKey = key + ':restore';
  const browsing = path => /\/(collections)(\/|$)/.test(path) || /\/search\/?$/.test(path);
  const product = path => /\/products\/[^/]+/.test(path);
  const read = () => {
    try {
      const state = JSON.parse(sessionStorage.getItem(key));
      const url = new URL(state.url, location.origin);
      if (url.origin !== location.origin || !browsing(url.pathname) || Date.now() - state.time > 86400000) return null;
      return {...state, url: url.href};
    } catch { return null; }
  };
  const save = target => {
    try {
      sessionStorage.setItem(key, JSON.stringify({url: location.href, y: window.scrollY, time: Date.now(), product: target?.pathname || ''}));
    } catch {}
  };
  if (browsing(location.pathname)) {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && product(url.pathname)) save(url);
    }, true);
    const restore = event => {
      const state = read();
      if (!state || state.url !== location.href || event?.persisted) return;
      let requested = false;
      try { requested = sessionStorage.getItem(restoreKey) === location.href; sessionStorage.removeItem(restoreKey); } catch {}
      const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
      if (!requested && !back) return;
      let attempts = 0;
      let cancelled = false;
      const cancel = () => { cancelled = true; };
      const events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
      events.forEach(type => window.addEventListener(type, cancel, {once: true, passive: true}));
      const tick = () => {
        if (cancelled) return;
        const max = document.documentElement.scrollHeight - window.innerHeight;
        window.scrollTo({top: Math.min(state.y, max), behavior: 'instant'});
        if (max >= state.y || ++attempts >= 40) {
          events.forEach(type => window.removeEventListener(type, cancel));
          return;
        }
        setTimeout(tick, 50);
      };
      requestAnimationFrame(tick);
    };
    window.addEventListener('pageshow', restore);
  }
  if (product(location.pathname)) {
    const state = read();
    const link = document.querySelector('[data-maslow-browse-back]');
    if (!link || !state) return;
    link.href = state.url;
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      try { sessionStorage.setItem(restoreKey, state.url); } catch {}
      // Native history restores the previous collection entry without adding another page.
      let referrer;
      try { referrer = new URL(document.referrer); } catch {}
      if (history.length > 1 && referrer?.href === state.url) {
        event.preventDefault();
        history.back();
      }
    });
  }
})();
